import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Sizechart from "./pages/Sizechart";
import AdminLayout from "./admin/AdminLayout";
import MainLayout from "./layout/Mainlayout";
import Dashboard from "./admin/Dashboard";
import Category from "./admin/Category";
import Subcategory from "./admin/Subcategory";
import Ordermanagement from "./admin/Ordermanagement";
import Productmanagement from "./admin/Productmanagement";
import AddNewproduct from "./admin/AddNewproduct";
import Blog from "./admin/Blog";
import AdminSizechart from "./admin/Sizechart";
import Usermanagement from "./admin/Usermanagement";
import General from "./admin/General";
import Cancelrefund from "./pages/Cancelrefund";
import contactus from "./pages/contactus";
import Privacypolicy from "./pages/Privacypolicy";
import Shipingpolicy from "./pages/Shipingpolicy";
import Termscondition from "./pages/Termscondition";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="/bsk-home" element={<Home />} />
          <Route path="bsk-about" element={<About />} />
          <Route path="bsk-size-chart" element={<Sizechart />} />
        </Route>

        <Route path="/bsk-secure-admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="category" element={<Category />} />
          <Route path="sub-category" element={<Subcategory />} />
          <Route path="order-management" element={<Ordermanagement />} />
          <Route path="user-management" element={<Usermanagement />} />
          <Route path="product-list" element={<Productmanagement />} />
          <Route path="new-product" element={<AddNewproduct />} />
          <Route path="blog" element={<Blog />} />
          <Route path="off-general" element={<General />} />
          <Route path="size-chart" element={<AdminSizechart />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
